<!-- Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and -->
<!-- matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, -->
<!-- including without limitation, material generated from the software programs which are displayed on the screen such -->
<!-- as icons, screen display looks, etc. -->

<div
  class="subscription-content"
  match-button-width
  (window:visibilitychange)="refresh()"
  role="region"
  [attr.aria-label]="'SDE_MANAGE_SUBSCRIPTION' | xdaTranslate">
  <div class="row">
    <div class="col-md-12">
      <h3 xdaTranslate>SDE_CURRENT_SUBSCRIPTION_INFORMATION</h3>
    </div>
  </div>

  @if (isSubscriptionExpired) {
    <div class="row">
      <div class="col-md-12">
        <p xdaTranslate>SDE_SUBSCRIPTION_EXPIRED</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button
          class="xrx-btn btn-secondary"
          (click)="redirect('purchase')"
          style="margin-top: 10px"
          xdaTranslate>
          SDE_PURCHASE_SUBSCRIPTION
        </button>
      </div>
    </div>
  } @else {
    @if (acquisition) {
      <div class="row">
        <div class="col-md-12">
          <p>
            <span class="font-weight-bold" xdaTranslate>SDE_PLAN1</span>
            <span style="padding-left: 5px" [xdaTranslate]="planName"></span>
          </p>
          @if (acquisition.usage && acquisition.usage.unitsPurchased != -1) {
            <div>
              <p>
                <span class="font-weight-bold" xdaTranslate
                  >SDE_JOBS_PURCHASED</span
                >
                {{ acquisition.usage.unitsPurchased }}
              </p>
              <p>
                <span class="font-weight-bold" xdaTranslate
                  >SDE_JOBS_REMAINING1</span
                >
                {{ acquisition.usage.unitsRemaining }}
              </p>
            </div>
          }
          <p>
            <span class="font-weight-bold" xdaTranslate>SDE_EXPIRATION2</span>
            {{ acquisition.licenseExpirationDate | date: 'longDate' }}
          </p>
        </div>
      </div>
    }
    <div class="row">
      <div class="col-md-12">
        <p
          [xdaTranslate]="'SDE_MAY_VIEW_OPTIONALLY'"
          [formatValues]="['AGNAME', 'AGNAME']"></p>
      </div>
    </div>
    @if (acquisition && acquisition.showRenewNotice) {
      <div class="row">
        <div class="col-md-12">
          <p xdaTranslate>SDE_SUBSCRIPTION_RENEWED_WILL</p>
        </div>
      </div>
    }
    <div class="row">
      <div class="col-md-12">
        <button
          class="xrx-btn btn-secondary"
          (click)="redirect('manage')"
          style="margin-top: 10px"
          xdaTranslate>
          SDE_SUBSCRIPTION_DETAILS
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h3 xdaTranslate>SDE_DEVICE_APP_INSTALLATION</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p
          [xdaTranslate]="'SDE_MAY_CHOOSE_INSTALL'"
          [formatValues]="['APPNAME', 'AGNAME']"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button
          class="xrx-btn btn-secondary"
          (click)="redirect('install')"
          style="margin-top: 10px"
          xdaTranslate>
          SDE_DEVICE_INSTALL
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h3 xdaTranslate>SDE_CREDIT_USAGE</h3>
      </div>
    </div>
    @if (acquisition) {
      <div class="row">
        <div class="col-md-12">
          <p>
            <span class="font-weight-bold" xdaTranslate
              >SDE_TOTAL_CREDITS_USED</span
            ><span>&nbsp;&nbsp;</span
            ><span
              [xdaTranslate]="'SDE_FMTSTR_AS_SUBSCRIPTION'"
              [formatValues]="[
                acquisition.usage.unitsUsed,
                acquisition.licenseStartDate | date: 'longDate',
              ]"></span>
          </p>
        </div>
      </div>
    }
    <div class="row">
      <div class="col-md-12">
        <button
          class="xrx-btn btn-secondary"
          (click)="usage()"
          style="margin-top: 10px"
          xdaTranslate>
          SDE_VIEW_USAGE
        </button>
      </div>
    </div>
  }
</div>
